import { axiosInstance } from '../../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../../Shared/Utils/UrlConstants';

const Service = {
  resetPassword: (data) => {
    return axiosInstance.post(ApiUrlConstant.resetPasswordService(), data, { loaderKey: 'resetPassword' });
  },
};

export default Service;
